"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CompareResult = /** @class */ (function () {
    function CompareResult() {
        this.equal = true;
        this.diff = [];
    }
    return CompareResult;
}());
exports.default = CompareResult;
//# sourceMappingURL=CompareResult.js.map